<template>
  <vue-scroll>
    <div class="flex column">
      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Abiertas"
            icon="el-icon-folder-opened primary-text"
            :total="Cards.OpenComplaints"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="En Proceso"
            icon="el-icon-magic-stick warning-text"
            :total="Cards.OnProcessComplaints"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Cerradas"
            icon="el-icon-folder-delete info-text"
            :total="Cards.ClosedComplaints"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Solucionadas"
            icon="el-icon-finished success-text"
            :total="Cards.SolvedComplaints"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-tabs
            type="border-card"
            :before-leave="beforeLeaveM"
            v-model="activeName"
          >
            <el-tab-pane label="Abiertas" name="0">
              <ComplaintTable ref="tab0" />
            </el-tab-pane>
            <el-tab-pane label="En proceso" name="1">
              <ComplaintTable ref="tab1" />
            </el-tab-pane>
            <el-tab-pane label="Cerradas" name="2">
              <ComplaintTable ref="tab2" />
            </el-tab-pane>
            <el-tab-pane label="Solucionadas" name="3">
              <ComplaintTable ref="tab3" />
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </vue-scroll>
</template>

<script>
import ComplaintTable from "@/components/ComplaintTable.vue";
import CardTotal from "@/components/CardTotalOriginal.vue";

export default {
  name: "ComplaintList",
  components: { ComplaintTable, CardTotal },
  data() {
    return {
      loading: Boolean,
      Cards: {
        ClosedComplaints: Number,
        OnProcessComplaints: Number,
        OpenComplaints: Number,
        SolvedComplaints: Number
      },
      trasnTabs: {
        Nueva: "Open",
        Cerrada: "Close"
      },
      activeName: "0",
      filters: {
        ComplaintType: {
          options: [
            {
              value: 0,
              label: "Administrativa"
            },
            {
              value: 2,
              label: "Soporte Técnico"
            },
            {
              value: 3,
              label: "Proyectos"
            },
            {
              value: 4,
              label: "Sistemas"
            }
          ],
          value: null
        }
      }
    };
  },

  mounted() {
    this.loading = true;
    this.$refs.tab0.getData(this.activeName, this.filters.ComplaintType.value);

    this.$http
      .get(
        `/api/ComplaintsAndClaims/GetSummaryComplaintsAndClaims?companyCode=${this.currentCompany}`
      )
      .then((resp) => {
        let { data } = resp;
        this.Cards.ClosedComplaints = data.ClosedComplaints;
        this.Cards.OnProcessComplaints = data.OnProcessComplaints;
        this.Cards.OpenComplaints = data.OpenComplaints;
        this.Cards.SolvedComplaints = data.SolvedComplaints;
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    beforeLeaveM(activeName, oldActiveName) {
      this.activeName = activeName;
      this.$refs[`tab${activeName}`].getData(
        activeName,
        this.filters.ComplaintType.value
      );
      return true;
    }
  },
  computed: {
    requestsGroup() {
      return this._.groupBy(
        this.requests,
        (request) => request.StatusDescription
      );
    }
  }
};
</script>

<style></style>
